import type { Animation } from '@ionic/core';
import { createAnimation, EASING_EMPHASIZED_ACCELERATE, growY } from '../../../utils/animations';

export function alertOpenAnimation(collapseElement: HTMLElement): Animation {
  const collapseAnim = createAnimation();
  const collapseItemHeight = collapseElement.offsetHeight;

  const openFade = (growY({ from: '0px', to: `${collapseItemHeight}px` }) as Animation)
    .addElement(collapseElement)
    .easing(EASING_EMPHASIZED_ACCELERATE);

  collapseAnim.addAnimation(openFade);
  return collapseAnim;
}
